// Built-in wallpaper presets. `value` is what gets stored in settings.wallpaper:
// null → the default, 'manga' → the animated manga tile, anything else → a CSS url.

const svgUrl = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const deepSpace = svgUrl(`<svg xmlns='http://www.w3.org/2000/svg' width='960' height='600'>
<defs><radialGradient id='g' cx='30%' cy='20%' r='110%'>
<stop offset='0' stop-color='#1b2a4a'/><stop offset='0.5' stop-color='#0c1226'/><stop offset='1' stop-color='#03050e'/>
</radialGradient></defs>
<rect width='960' height='600' fill='url(#g)'/>
<g fill='#fff'>
<circle cx='80' cy='90' r='1.6'/><circle cx='220' cy='40' r='1'/><circle cx='340' cy='150' r='1.4'/>
<circle cx='470' cy='70' r='1'/><circle cx='610' cy='120' r='1.8'/><circle cx='760' cy='50' r='1.1'/>
<circle cx='880' cy='170' r='1.5'/><circle cx='150' cy='260' r='1.2'/><circle cx='420' cy='300' r='1'/>
<circle cx='700' cy='280' r='1.4'/><circle cx='840' cy='380' r='1'/><circle cx='90' cy='430' r='1.7'/>
<circle cx='300' cy='480' r='1.1'/><circle cx='540' cy='430' r='1.5'/><circle cx='920' cy='520' r='1.2'/>
<circle cx='680' cy='540' r='1'/><circle cx='200' cy='560' r='1.3'/>
</g>
<circle cx='740' cy='150' r='46' fill='#2c3e66' opacity='0.9'/>
<circle cx='726' cy='138' r='9' fill='#1b2947'/><circle cx='756' cy='168' r='6' fill='#1b2947'/>
</svg>`);

const synthwave = svgUrl(`<svg xmlns='http://www.w3.org/2000/svg' width='960' height='600'>
<defs>
<linearGradient id='sky' x1='0' y1='0' x2='0' y2='1'>
<stop offset='0' stop-color='#16063a'/><stop offset='0.62' stop-color='#5f1a78'/><stop offset='0.8' stop-color='#d9376e'/>
</linearGradient>
<linearGradient id='sun' x1='0' y1='0' x2='0' y2='1'>
<stop offset='0' stop-color='#ffd447'/><stop offset='1' stop-color='#ff2975'/>
</linearGradient>
</defs>
<rect width='960' height='600' fill='url(#sky)'/>
<circle cx='480' cy='430' r='150' fill='url(#sun)'/>
<g fill='#16063a'><rect x='330' y='390' width='300' height='8'/><rect x='330' y='414' width='300' height='11'/>
<rect x='330' y='444' width='300' height='14'/><rect x='330' y='478' width='300' height='18'/></g>
<rect y='480' width='960' height='120' fill='#0d0221'/>
<g stroke='#ff2ea6' stroke-width='1.4' opacity='0.85'>
<path d='M0 480 H960 M0 505 H960 M0 535 H960 M0 572 H960'/>
<path d='M480 480 480 600 M380 480 300 600 M280 480 110 600 M180 480 -90 600 M580 480 660 600 M680 480 850 600 M780 480 1050 600'/>
</g>
</svg>`);

const graphiteWaves = svgUrl(`<svg xmlns='http://www.w3.org/2000/svg' width='960' height='600'>
<defs><linearGradient id='bg' x1='0' y1='0' x2='0' y2='1'>
<stop offset='0' stop-color='#3b4451'/><stop offset='1' stop-color='#14181f'/>
</linearGradient></defs>
<rect width='960' height='600' fill='url(#bg)'/>
<path d='M0 340 C 240 260 420 430 660 350 S 960 300 960 300 V600 H0 Z' fill='#2a313c' opacity='0.9'/>
<path d='M0 420 C 260 350 460 500 720 420 S 960 400 960 400 V600 H0 Z' fill='#1e242d' opacity='0.95'/>
<path d='M0 500 C 300 440 520 570 960 480 V600 H0 Z' fill='#151a21'/>
</svg>`);

export const MANGA_URL =
  'https://3.bp.blogspot.com/_ImecizcBRRU/TS6TU8NQ95I/AAAAAAAABdE/FRG5NyHoGR4/s1600/naruto_016-017.png';

export const DEFAULT_WALLPAPER = '/wallpaper/aurora.jpg';

export const WALLPAPERS = [
  { id: 'aurora', label: 'Aurora', value: null, preview: DEFAULT_WALLPAPER },
  { id: 'deep-space', label: 'Deep Space', value: deepSpace, preview: deepSpace },
  { id: 'synthwave', label: 'Synthwave Grid', value: synthwave, preview: synthwave },
  { id: 'graphite-waves', label: 'Graphite Waves', value: graphiteWaves, preview: graphiteWaves },
  { id: 'manga', label: 'Manga Motion', value: 'manga', preview: MANGA_URL },
];
